module.exports = __webpack_public_path__ + "spotify-a80a7d3ee47fd236246e.svg";